export const validatePhone = (mobileNumber) => {
    // let isPaltel = new RegExp('^[0-9]{2}[0-9]{7}$').test(mobileNumber);
    let isJawwal = new RegExp('^059[0-9]{7}$').test(mobileNumber);
    let isWm = new RegExp('^056[0-9]{7}$').test(mobileNumber);

    return isJawwal || isWm;
};